/**
 * 観測所一覧
 */
import Repository from "./Repository";

const resource = "";
export default {
  /**
   * 雨量観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmRainPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsRain/past` + param);
  },
  /**
   * 流域平均雨量観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmBsnPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsBsn/past` + param);
  },
  /**
   * 積雪深観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmSnowPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsSnow/past` + param);
  },
  /**
   * 通常水位観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmStagePast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsStage/past` + param);
  },
  /**
   * 水質観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmWtrQualPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsWtrQual/past` + param);
  },
  /**
   * ダム諸量観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmDamPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsDam/past` + param);
  },
  /**
   * 海岸観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmCoastPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsCoast/past` + param);
  },
  /**
   * レーダ流域平均雨量観測値過去情報一覧 取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   * @param date 取得開始日
   */
  getSelectedTmRdBsnPast(payload) {
    const param =
      "/" +
      payload.ofcCd +
      "/" +
      payload.itmkndCd +
      "/" +
      payload.obsCd +
      "/" +
      payload.date;
    return Repository.get(`${resource}/tmObsRdBsn/past` + param);
  },
  /**
   * 市町村情報取得
   * @param keyList 検索条件（全国：都道府県リスト、地方：市町村リスト）
   * @param isPref 検索条件（都道府県で検索の場合true、市町村で検索の場合false）
   */
  getTwnInfo(payload) {
    var list = Array();
    for (var key of payload.keyList) {
      list.push(key.id);
    }
    var param =
      "/" +
      list +
      "/" +
      payload.appTime +
      "/" +
      payload.isCurrent +
      "/" +
      payload.isPref;
    return Repository.get(`${resource}/tmListTwn` + param);
  },
  /**
   * 水系別情報取得
   * @param keyList 検索条件（全国：都道府県リスト、地方：市町村リスト）
   * @param isPref 検索条件（都道府県で検索の場合true、市町村で検索の場合false）
   */
  getRsysInfo(payload) {
    var list = Array();
    for (var key of payload.keyList) {
      list.push(key.id);
    }
    var param =
      "/" +
      list +
      "/" +
      payload.appTime +
      "/" +
      payload.isCurrent +
      "/" +
      payload.isPref;
    return Repository.get(`${resource}/tmListRsys` + param);
  },
  /**
   * 都道府県市町村別テレメータ情報取得
   * @param twnCd 市町村コード
   * @param appTime 対象日時
   * @param isCurrent 観測日時 [true:最新, false:履歴]
   */
  getTmDatasByTown(payload) {
    const param =
      "/" + payload.twnCd + "/" + payload.appTime + "/" + payload.isCurrent;
    return Repository.get(`${resource}/tmListTwnDatas` + param);
  },
  /**
   * 都道府県市町村別テレメータ情報一括取得
   * @param keyList 検索条件（全国：都道府県リスト、地方：市町村リスト）
   * @param appTime 対象日時
   * @param isCurrent 観測日時 [true:最新, false:履歴]
   * @param isPref 検索条件（都道府県で検索の場合true、市町村で検索の場合false）
   */
  getAllTmDatasByTown(payload) {
    var list = Array();
    for (var key of payload.keyList) {
      list.push(key.id);
    }
    const param =
      "/" +
      list +
      "/" +
      payload.appTime +
      "/" +
      payload.isCurrent +
      "/" +
      payload.isPref;
    return Repository.get(`${resource}/tmListTwnAllDatas` + param);
  },
  /**
   * 水系河川別テレメータ情報取得
   * @param rvrCd 河川番号
   * @param appTime 対象日時
   * @param isCurrent 観測日時 [true:最新, false:履歴]
   */
  getTmDatasByRsys(payload) {
    const param =
      "/" + payload.rvrCd + "/" + payload.appTime + "/" + payload.isCurrent;
    return Repository.get(`${resource}/tmListRsysDatas` + param);
  },
  /**
   *  水系河川別テレメータ情報一括取得
   * @param keyList 検索条件（全国：都道府県リスト、地方：市町村リスト）
   * @param appTime 対象日時
   * @param isCurrent 観測日時 [true:最新, false:履歴]
   * @param isPref 検索条件（都道府県で検索の場合true、市町村で検索の場合false）
   */
  getAllTmDatasByRsys(payload) {
    var list = Array();
    for (var key of payload.keyList) {
      list.push(key.id);
    }
    const param =
      "/" +
      list +
      "/" +
      payload.appTime +
      "/" +
      payload.isCurrent +
      "/" +
      payload.isPref;
    return Repository.get(`${resource}/tmListRsysAllDatas` + param);
  },
};
